<template>
  <div>
    <div class="d-flex super-sign-banner banner-div row">
      <div class="bannerDiv col-sm-1  col-md-1"></div>
      <div class="bannerDiv col-sm-4 col-md-4">
        <br />
        <h3 class="bannerDivone">iOS超级签名</h3>
        <br />
        <h6 class="bannerDivtwo">支持账号公有池和私有池</h6>
        <p class="bannerDivtwo"></p>
        <h6>支持下载码安装、安装数控制</h6>
        <p class="bannerDivtwo"></p>
        <h6 data-v-47224b77="" class="bannerDivthree">不一样的iOS签名，告别掉签烦恼，提高应用分发效率，节省大量时间和获客成本</h6>
        <p class="bannerDivtwo"></p>
        <h6>系统技术支持BSign</h6>
        <br />
        <el-button style="width:10em" @click="startSuperSign">立即使用</el-button>
      </div>
      <div class="col-sm-6 col-md-6">
        <img class="banner-img" src="../assets/img/super_sign_banner.png" />
      </div>
      <div class="bannerDiv col-sm-1 col-md-1"></div>
    </div>
    <br />
    <div class="module-inner">
      <div class="actions-box">
        <h2>功能介绍</h2>
        <br />
        <div class="list row">
          <div class="item col-sm-3">
            <img src="../assets/img/easy-icon.png" alt="">
            <p></p>
            <h6>掉签概率低</h6>
            <p>特殊签名机制，多证书分布式签名</p>
            <p>低于企业签名的掉率概率，理论上最长可使用一年</p>
          </div>
          <div class="line"></div>
          <div class="item col-sm-3">
            <img src="../assets/img/cloud-icon.png" alt="">
            <p></p>
            <h6>无需上架，无需越狱</h6>
            <p>可以直接分享下载链接下载安装</p>
            <p>不需要上架AppStore，也不需要手机越狱</p>
          </div>
          <div class="item col-sm-3">
            <img src="../assets/img/safe-icon.png" alt="">
            <p></p>
            <h6>不植入插件，无后门</h6>
            <p>不以统计启动次数为由植入插件</p>
            <p>保持应用原样，无后顾之忧</p>
          </div>
          <div class="item col-sm-3">
            <img src="../assets/img/more-icon.png" alt="">
            <p></p>
            <h6>私有开发者账号</h6>
            <p>设备与开发者账号可独立、可共享</p>
            <p>不同应用可绑定同一开发者账号</p>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div class="prd-box">
        <h2>产品优势</h2>
        <p></p>
        <p>不一样的 iOS 签名，不一样的优点</p>
        <div class="sign-list row">
          <div class="super-desc col-sm-2"></div>
          <div class="super-desc col-sm-4">
            <img src="../assets/img/supersign-box.png">
            <div class="desc">
              <div class="title">
                <h4>iOS 超级签名</h4>
              </div>
              <div class="content">
                <p></p>
                <p>特殊签名机制，掉签概率远低于企业签名</p>

                <p>按设备收费，一次最长可用一年</p>

                <p>每台设备不管下载多少应用，只收一次费用</p>

                <p>适合用户量小或固定用户的应用</p>
              </div>
            </div>
          </div>
          <div class="sign-desc col-sm-4">
            <img src="../assets/img/sign-box.png">
            <div class="desc" style="margin-top:-23em;">
              <div class="title">
                <h4>iOS 企业签名</h4>
              </div>
              <div class="content">
                <p></p>
                <p>随着苹果审核越来越严格，掉签风险逐日剧增</p>

                <p>每次掉签都可能留失用户</p>

                <p>按签名时长收费</p>

                <p>适合用户量大的应用</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    var token = this.getToken();
    if (token != null && token != "" && token != undefined) {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/token", {
          authToken: this.getToken()
        })
        .then(response => {
          this.respDataHandle(response.body, respData => {
            this.$emit("setNoLogin", false);
            this.$emit("setAccount", respData);
          });
        });
    }
  },
  data() {
    return {};
  },
  methods: {
    startSuperSign: function() {
      var token = this.getToken();
      if (token == null || token == "" || token == undefined) {
        this.$router.push({ name: "login" });
      } else {
        this.$router.push({ name: "SuperSignApps" });
      }
    }
  },
  components: {}
};
</script>

<style scoped>
@media (max-width: 768px) {
  .banner-img {
    margin-top: 2em;
    height: 16em;
  }
}

@media only screen and (min-width: 1200px) {
  .banner-img {
    margin-top: 6em;
    height: 25em;
    width: 35em;
  }
}

.module-inner {
  margin-top: 1em;
}

.item img {
  height: 6em;
}

.super-desc img {
  width: 26em;
  height: 28em;
}

.sign-desc img {
  width: 25em;
  height: 27em;
}

.desc {
  margin-top: -24em;
  z-index: auto;
  height: 35em;
}

.desc .title {
  margin-left: -10em;
}

.desc .content {
  margin-top: 2em;
}
.desc p {
  line-height: 3em;
  color: #9b9b9b;
}
</style>


// WEBPACK FOOTER //
// src/components/SuperSign.vue